import 'magnific-popup'
import $ from 'jquery'

class Interstitial {
  constructor() {
    console.log('Interstitial: started');
    const interstitials = document.querySelectorAll('.block--type--interstitial');

    if (interstitials.length === 0) return;

    interstitials.forEach((interstitial) => {
      // 1. Define elements consistently
      const reOpenButton = document.querySelector('div.supreme-popup');
      const reelButton = document.querySelector('div.reels-box');

      const closeButton = interstitial.querySelector('a.close');

      // 2. Define reusable Open Function
      const openPopup = () => {
        // Hide re-open button while popup is active
        if (reOpenButton) reOpenButton.style.display = 'none';
        if (reelButton) reelButton.style.display = 'none';

        // CAPTURE CURRENT SCROLL POSITION
        let scrollY = window.scrollY;

        $.magnificPopup.open({
          items: {
            src: interstitial,
            type: 'inline'
          },
          overflowY: 'scroll',
          callbacks: {
            open: function() {
              scrollY = window.scrollY;

              document.body.style.position = 'fixed';
              document.body.style.top = `-${scrollY}px`;
              document.body.style.width = '100%';
              // document.body.style.paddingRight = '15px';
            },
            close: function () {
              const scrollY = document.body.style.top;
              document.body.style.position = '';
              document.body.style.top = '';
              document.body.style.width = '';
              document.body.style.paddingRight = '';

              // RESTORE: Scroll instantly back to where the user was
              window.scrollTo(0, parseInt(scrollY || '0') * -1);

              // Show re-open button when popup closes
              if (reOpenButton) reOpenButton.style.display = 'block';
              if (reelButton) reelButton.style.display = 'flex';

              window.sessionStorage.setItem('supreme-popup', 'closed');
            }
          }
        });
      };

      // 3. Logic: Check Storage on Load
      if (window.sessionStorage.getItem('supreme-popup') !== 'closed') {
        openPopup();
      } else {
        console.log('Interstitial: Suppressed by storage');
        // Just show the button immediately
        if (reOpenButton) reOpenButton.style.display = 'block';
        if (reelButton) reelButton.style.display = 'flex';

      }

      // 4. MISSING PIECE: Make the button actually work!
      if (reOpenButton) {
        reOpenButton.addEventListener('click', (e) => {
          e.preventDefault();
          openPopup();
        });
      }

      // 5. Logic: Close Trigger (Inside Popup)
      if (closeButton) {
        closeButton.addEventListener("click", (e) => {
          e.preventDefault();
          $.magnificPopup.close();
        });
      }
    });

    // Generic links (unchanged)
    $('a').each(function () {
      const href = $(this).attr('href')
      if (typeof href !== 'undefined' && href.startsWith('#') && href.length > 1 && $(href).hasClass('block--type--interstitial')) {
        $(this).magnificPopup({
          items: { src: href, type: 'inline' },
          overflowY: 'scroll'
        })
      }
    })
  }
}

export default Interstitial;